import {MRT_Row} from 'material-react-table';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import type CreatorGroupMembership from '@/types/creatorGroupMembership';
import UsernameCell from '@/views/creators/components/creators-table/UsernameCell';
import {
  crmProfileUrlFor,
  isOffPlatformCreator,
} from '@/views/creators/creator-crm/utils/offPlatformCreator';
import Link from '@/components/link';
import useListCreatorsStore, {
  listCreatorsActions,
} from '@/stores/list-creators/listCreatorsStore';

function CreatorNameCell({row}: {row: MRT_Row<CreatorGroupMembership>}) {
  const {id} = row.original;
  const isOffPlatform = isOffPlatformCreator(row.original);
  const profileId = row.original.profile?.id;
  const profileUrl = profileId
    ? crmProfileUrlFor({
        id: profileId,
        source: row.original.source,
      })
    : undefined;
  const isSelected = useListCreatorsStore(
    useShallow((state) => state.selectedCreators.has(id))
  );

  const imageUrl = row.original.profile?.imageUrl ?? '';
  const displayName =
    row.original.profile?.displayName ??
    row.original.email ??
    'Deactivated creator';

  const onCheckboxChange = React.useCallback(() => {
    listCreatorsActions.toggleCreator(id, row.original);
  }, [id, row.original]);

  const cell = (
    <UsernameCell
      profileId={profileId ?? id}
      showProfilePopup={!isOffPlatform}
      isOffPlatform={isOffPlatform}
      name={displayName}
      picture={imageUrl}
      isSelected={isSelected}
      onCheckboxChange={onCheckboxChange}
      profile={row.original.profile}
      email={row.original?.email}
    />
  );

  if (!profileUrl) {
    return cell;
  }

  return (
    <Link to={profileUrl} target="_blank">
      {cell}
    </Link>
  );
}

const CreatorNameCellMemo = React.memo(CreatorNameCell);

export default CreatorNameCellMemo;
